<template>
    <base-dialog :loading="loading" :value="dialog" :width="420" :title="$t('student.you_have_pending_invitations')" persistent
        hide-close>
        <div class="wi-coach">
            <div class="wi-avatar">
                <v-img v-if="coachAvatar" eager cover :src="coachAvatar" class="wi-avatar-img" />
                <v-icon v-else size="26" color="txtMuted">mdi-account</v-icon>
            </div>
            <div class="wi-info">
                <span class="wi-name">{{ coachName }}</span>
                <span v-if="coachDescription" class="wi-description">{{ coachDescription }}</span>
            </div>
        </div>

        <p class="wi-body">{{ $t('student.invitation_welcome_body', { coach: coachName }) }}</p>
        <p class="wi-hint">{{ $t('student.invitation_welcome_later_hint') }}</p>

        <template v-slot:footer>
            <div class="wi-actions">
                <v-btn depressed height="44" class="normal-btn wi-btn" :disabled="loading" @click="later">
                    {{ $t('student.invitation_welcome_later') }}
                </v-btn>
                <v-btn depressed height="44" color="primary" class="normal-btn wi-btn black--text" :loading="loading"
                    @click="accept">
                    {{ $t('common.accept') }}
                </v-btn>
            </div>
        </template>
    </base-dialog>
</template>

<script>
import firebase from "@/utils/Firebase";
import BaseDialog from "@/components/common/BaseDialog";

export default {
    name: "WelcomeInvitationDialog",
    components: { BaseDialog },
    props: {
        invitation: {
            type: Object,
            default: null,
        }
    },
    data() {
        return {
            dialog: false,
            loading: false,
        }
    },
    computed: {
        coach(vm = this) {
            return vm.invitation?.coach || null
        },
        coachName(vm = this) {
            return vm.coach?.name || vm.$t('common.coach')
        },
        coachAvatar(vm = this) {
            return vm.coach?.avatar || null
        },
        coachDescription(vm = this) {
            return vm.coach?.description || ''
        },
    },
    methods: {
        acceptInvitation: firebase.functions().httpsCallable('httpInvitations-acceptStudentInvitation'),
        show() {
            const vm = this
            vm.dialog = true
        },
        hide() {
            const vm = this
            vm.dialog = false
        },
        async accept() {
            const vm = this
            vm.loading = true
            try {
                await vm.acceptInvitation({ invitationID: vm.invitation.id })
                vm.toast(vm.$t('student.invitation_accepted'))
            } catch (err) {
                vm.toast(`${vm.$t('common.an_error_has_occurred')}: ${err.message}`, 'error')
            }
            vm.loading = false
            vm.hide()
            vm.$emit('done')
        },
        later() {
            const vm = this
            vm.hide()
            vm.$emit('done')
        },
    },
}
</script>

<style scoped>
.wi-coach {
    display: flex;
    align-items: center;
    gap: 12px;
}

.wi-avatar {
    width: 52px;
    height: 52px;
    border-radius: 50%;
    background: var(--v-surface2-base);
    border: 1px solid var(--v-outline2-base);
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    flex-shrink: 0;
}

.wi-avatar-img {
    width: 100%;
    height: 100%;
}

.wi-info {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
}

.wi-name {
    font-size: 15px;
    font-weight: 700;
    color: var(--v-txtPrimary-base);
}

.wi-description {
    font-size: 12px;
    color: var(--v-txtMuted-base);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.wi-body {
    font-size: 13px;
    color: var(--v-txtSecondary-base);
    margin: 16px 0 0;
}

.wi-hint {
    font-size: 12px;
    color: var(--v-txtMuted-base);
    margin: 8px 0 0;
}

.wi-actions {
    display: flex;
    gap: 10px;
    width: 100%;
    padding: 14px 16px;
}

.wi-btn {
    flex: 1;
    font-weight: 700;
}
</style>
